import { withStyles } from '@material-ui/styles';
import TimeLineItem from './TimeLineItem';
import styles from './styles';

export default withStyles(styles)(TimeLineItem);
